<template>
  <div class="cell-container">
    <!-- <div class="image"><img src="@/assets/ksxg/pic.png" /></div>
    <div class="text">
      <h1>挺住！驰声口语评测技术“声”援湖北在线教育企业;挺住！</h1>
      <span>
        针对湖北地区的新老客户，驰声从即日起提供语音评测资源的支持。欢迎联系我们，驰声语音评测技术专家团队随时为您守候。针对湖北地区的新老客户，驰声从即日起提供语音评测资源的支持。欢迎联系我们，驰声语音评测技术专家团队随时为您守候。</span
      >
      <div class="date">2020-2-10</div>
    </div> -->
    <div class="image"><img src="@/assets/ksxg/tixing.png" /></div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.cell-container {
  transition: all 0.6s;

  width: 1200px;
  margin: 20px auto;
  display: flex;
  .image {
    display: inline-block;
    width: 300px;
    // background-color: #f7f9fb;
    height: 127px;
    img {
      // width: 100%;
      // height: 100%;
      // background-color: #7db7f1;
    }
  }

  .text {
    display: inline-block;
    width: 900px;
    padding: 10px 20px;
    .date {
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
    }
  }
}
</style>
